import type { WeightClassPayload } from "@bracket/idl/main/fight/model/FightPt"

/**
 * 체급 선택지.
 *
 * 확정 요청에는 서버가 내려준 payload 를 **그대로 되돌려 보낸다** —
 * 종목별 oneof 를 화면이 다시 조립하면 종목과 어긋난 값이 만들어질 수 있다.
 */
interface WeightClassOption {
  /** 목록 렌더링 키 (종목 + 표시명) */
  key: string
  name: string
  payload: WeightClassPayload
}

/** 관리자 신청 목록 검색 조건 */
interface AdminEntrySearchInput {
  tournamentId: string
  gymName: string
  playerName: string
  status: string
  sport: string
}

function makeInitAdminEntrySearch(): AdminEntrySearchInput {
  return {
    tournamentId: "",
    gymName: "",
    playerName: "",
    status: "",
    sport: "",
  }
}

export { makeInitAdminEntrySearch }
export type { AdminEntrySearchInput, WeightClassOption }
